import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=472263c1&"
import script from "./CallToAction.vue?vue&type=script&lang=js&"
export * from "./CallToAction.vue?vue&type=script&lang=js&"
import style0 from "./CallToAction.vue?vue&type=style&index=0&id=472263c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports